import React from 'react';
import classNames from 'classnames';
import { Select } from '../forms';
import './footer.scss';

const Footer = props => {
    return (
        <footer className={classNames({
            'export-footer': true,
            'export-footer--exporting': props.isExporting,
            'export-footer--finished': props.isExportingFinished,
            ...props.modifiers
        })}>
            {props.children &&
                <Select modifiers={{'form__select--small': true}} value={props.value} onChange={props.onChange} name={props.name}>
                    {props.children}
                </Select>
            }
            
            {props.btnComponent}
        </footer>
    );
};

export default Footer;